export default __webpack_public_path__ + "static/media/Adam.b802baba.webp";